import { useUIStore } from 'store';
import BottomBar from './BottomBar';

const BottomBarWithRecoil = (props: any) => {
  const bottomBarOpen = useUIStore((state) => state.bottomBarOpen);
  const setBottomBarOpen = useUIStore((state) => state.setBottomBarOpen);
  return <BottomBar {...props} reelOpen={bottomBarOpen} setReelOpen={setBottomBarOpen} />;
};

export default BottomBarWithRecoil;
